import { ReactNode } from 'react';
import { cn } from '@/service/utils/cn';

type TTooltipProps = {
    tooltipClassName?: string;
    className?: string;
    text: string | ReactNode;
    placement?: 'left' | 'right';
    children: ReactNode;
};

export const Tooltip = ({
    tooltipClassName,
    className,
    text,
    placement,
    children,
}: TTooltipProps) => (
    <div
        className={cn(
            'group relative min-h-max min-w-max overflow-hidden transition-opacity hover:overflow-visible',
            className
        )}
    >
        {text ? (
            <div
                className={cn(
                    `tx-large-medium absolute -right-9 bottom-4 z-50 w-[238px] rounded-[15px] bg-gradient-to-r from-blue-4 to-blue-12 pb-3 pl-5 pr-3.5 pt-3 text-white opacity-0 shadow-lightCard after:absolute after:-z-10 after:flex after:h-2 after:w-2 after:rotate-45 after:items-center after:justify-center after:rounded-sm after:bg-blue-12 after:content-[''] group-hover:opacity-100 dark:shadow-dark sm:-right-8 sm:w-[397px]
                    sm:pb-5 sm:pt-3.5 ${
                        placement && placement === 'left'
                            ? 'bottom-6 left-0 after:-bottom-1 after:left-7 after:bg-blue-4'
                            : 'bottom-6 after:-bottom-1 after:right-7'
                    }`,
                    tooltipClassName
                )}
            >
                {text}
                <div className=""></div>
            </div>
        ) : null}
        {children}
    </div>
);
